import { render, staticRenderFns } from "./motorcycle.vue?vue&type=template&id=f37b847a&scoped=true&"
import script from "./motorcycle.vue?vue&type=script&lang=js&"
export * from "./motorcycle.vue?vue&type=script&lang=js&"
import style0 from "./motorcycle.vue?vue&type=style&index=0&id=f37b847a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37b847a",
  null
  
)

export default component.exports